<!-- <script src="js/flexible.js"></script>
<script src="js/jquery.js"></script>
<script src="js/echarts.min.js"></script>
<script src="js/index.js"></script>
<script src="js/china.js"></script>
<script src="js/myMap.js"></script> -->

<template>
  <body id="bodytest">
    <!-- <div id="app"> -->
    <div class="home-page-container">
      <!-- 导航栏 -->
      <header :class="{ scrolled: isScrolled }">
        <div class="navbar">
          <div class="logo" @click="scrollToTop">
            <i class="fas fa-heartbeat logo-icon"></i>
            <div class="logo-text">大白主动健康</div>
          </div>
          <div class="nav-links" :class="{ active: mobileMenuOpen }">
            <a
              v-for="(link, index) in navLinks"
              :key="index"
              :href="'#' + link.id"
              :class="{ active: activeSection === link.id }"
              @click="mobileMenuOpen = false"
            >
              {{ link.text }}
            </a>
          </div>
          <button class="mobile-menu-btn" @click="toggleMobileMenu">
            <i class="fas fa-bars"></i>
          </button>
          <a href="#" class="cta-button">免费体验</a>
        </div>
      </header>

      <!-- 主视觉区域 -->
      <section class="hero" id="home">
        <div class="hero-content" :class="{ show: animated }">
          <h1>您的个人<span class="hero-gradient">大白主动健康</span></h1>
          <p>
            基于AI的健康数据分析平台，全天候守护您和家人的健康安全，数据隐私是我们最重视的承诺
          </p>
          <div class="hero-buttons">
            <button
              class="cta-button"
              @click="scrollToSection('features')"
              style="margin-right: 20px"
            >
              开始使用
            </button>
            <a
              :href="'#' + navLinks[4].id"
              class="cta-button"
              style="margin-left: 20px"
              >下载应用</a
            >
          </div>
        </div>
        <div
          class="hero-image"
          :class="{ show: animated }"
          style="transition-delay: 0.2s"
        >
          <div class="dashboard-preview">
            <div class="dashboard-chart">
              <div class="chart-title">心率监测 (次/分)</div>
              <div class="chart-container" id="heartRateChart"></div>
            </div>
            <div class="dashboard-chart">
              <div class="chart-title">睡眠质量分析</div>
              <div class="chart-container" id="sleepChart"></div>
            </div>
            <div class="dashboard-chart">
              <div class="chart-title">每日步数趋势</div>
              <div class="chart-container" id="stepsChart"></div>
            </div>
            <div class="dashboard-chart">
              <div class="chart-title">血压变化 (mmHg)</div>
              <div class="chart-container" id="bpChart"></div>
            </div>
          </div>
        </div>
      </section>

      <!-- 核心价值部分 -->
      <section class="values" id="values">
        <div class="section-title" :class="{ show: animated }">
          <h2>为什么选择大白主动健康</h2>
          <p>我们重新定义了健康管理，将专业医疗级分析与用户隐私保护完美结合</p>
        </div>
        <div class="value-cards">
          <div
            v-for="(value, index) in values"
            :key="index"
            class="value-card"
            :class="{ show: animated }"
            :style="{ 'transition-delay': `${index * 0.1}s` }"
            @click="showFeatureInfo(value)"
          >
            <div class="value-icon">
              <i :class="value.icon"></i>
            </div>
            <h3>{{ value.title }}</h3>
            <p>{{ value.description }}</p>
          </div>
        </div>
      </section>

      <!-- 产品功能部分 -->
      <section class="features" id="features">
        <div class="section-title" :class="{ show: animated }">
          <h2>全面健康管理功能</h2>
          <p>从数据采集到专业分析，全方位守护您的健康</p>
        </div>
        <div class="features-grid">
          <div
            v-for="(feature, index) in features"
            :key="index"
            class="feature-card"
            :class="{ show: animated }"
            :style="{ 'transition-delay': `${index * 0.1}s` }"
          >
            <div class="feature-image">
              <i :class="feature.icon"></i>
            </div>
            <div class="feature-content">
              <h3>{{ feature.title }}</h3>
              <p>{{ feature.subtitle }}</p>
              <ul class="feature-list">
                <li v-for="(item, i) in feature.items" :key="i">{{ item }}</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <!-- 安全隐私部分 -->
      <section class="security" id="security">
        <div class="security-content">
          <div class="security-text" :class="{ show: animated }">
            <h2>您的健康数据绝对安全</h2>
            <p>
              我们采用银行级别的安全措施保护您的健康数据，所有信息均在中国大陆安全存储，绝不跨境传输。
            </p>

            <div class="security-points">
              <div
                v-for="(point, index) in securityPoints"
                :key="index"
                class="security-point"
                :class="{ show: animated }"
                :style="{ 'transition-delay': `${index * 0.1}s` }"
                @click="selectSecurityPoint(index)"
              >
                <div class="security-icon">
                  <i :class="point.icon"></i>
                </div>
                <div>
                  <h3>{{ point.title }}</h3>
                  <p>{{ point.description }}</p>
                </div>
              </div>
            </div>
          </div>
          <div
            class="security-image"
            :class="{ show: animated }"
            style="transition-delay: 0.3s"
          >
            <i :class="currentSecurity.icon"></i>
            <p>{{ currentSecurity.title }}</p>
          </div>
        </div>
      </section>

      <!-- 下载区域 -->
      <section class="download" id="download">
        <div class="download-content" :class="{ show: animated }">
          <h2>立即开始健康守护之旅</h2>
          <p>下载我们的应用，开启个性化健康管理体验</p>

          <div class="download-buttons">
            <a
              v-for="(btn, index) in downloadButtons"
              :key="index"
              class="download-btn"
            >
              <i :class="btn.icon"></i>
              <div @click="toDownload(btn)">
                <div style="font-size: 0.9rem">{{ btn.subtitle }}</div>
                <div style="font-size: 1.4rem">{{ btn.title }}</div>
              </div>
            </a>
          </div>

          <div
            style="
              margin-top: 50px;
              display: flex;
              justify-content: center;
              gap: 20px;
            "
          >
            <div style="text-align: center">
              <div style="font-size: 1.2rem; margin-bottom: 10px">扫码下载</div>
              <div
                style="
                  width: 150px;
                  height: 150px;
                  background: rgba(255, 255, 255, 0.1);
                  border-radius: 10px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  margin: 0 auto;
                "
              >
                <div
                  style="
                    width: 120px;
                    height: 120px;
                    background: linear-gradient(135deg, #00b3b3, #0066cc);
                    border-radius: 8px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <i
                    class="fas fa-qrcode"
                    style="font-size: 4rem; color: white"
                  ></i>
                </div>
              </div>
            </div>
            <div style="text-align: center">
              <div style="font-size: 1.2rem; margin-bottom: 10px">应用预览</div>
              <div
                style="
                  width: 150px;
                  height: 150px;
                  background: rgba(255, 255, 255, 0.1);
                  border-radius: 10px;
                  overflow: hidden;
                  margin: 0 auto;
                "
              >
                <div
                  style="
                    width: 100%;
                    height: 100%;
                    background: linear-gradient(
                        rgba(0, 102, 204, 0.7),
                        rgba(0, 179, 179, 0.7)
                      ),
                      url('https://images.unsplash.com/photo-1551963831-b3b1ca40c98e?ixlib=rb-1.2.1&auto=format&fit=crop&w=2070&q=80')
                        center/cover no-repeat;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <i
                    class="fas fa-mobile-alt"
                    style="font-size: 3rem; color: white"
                  ></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 页脚 -->
      <footer>
        <div class="footer-grid">
          <div class="footer-col">
            <div class="logo" @click="scrollToTop">
              <i class="fas fa-heartbeat logo-icon"></i>
              <div class="logo-text">大白主动健康</div>
            </div>
            <p style="margin: 20px 0; opacity: 0.8">
              您的个人健康管理专家，数据安全是我们的首要承诺
            </p>
            <div class="social-links">
              <a
                v-for="(social, index) in socialLinks"
                :key="index"
                :href="social.link"
                style="color: #a3d9ff; font-size: 1.5rem; margin-right: 15px"
              >
                <i :class="social.icon"></i>
              </a>
            </div>
          </div>

          <div class="footer-col">
            <h3>产品服务</h3>
            <ul class="footer-links">
              <li v-for="(service, index) in services" :key="index">
                <a :href="service.link">{{ service.name }}</a>
              </li>
            </ul>
          </div>

          <div class="footer-col">
            <h3>关于我们</h3>
            <ul class="footer-links">
              <li v-for="(about, index) in aboutLinks" :key="index">
                <a :href="about.link">{{ about.name }}</a>
              </li>
              <li><a @click="openArchive">营业执照</a></li>
            </ul>
          </div>

          <div class="footer-col">
            <h3>联系我们</h3>
            <div
              class="contact-item"
              v-for="(contact, index) in contacts"
              :key="index"
            >
              <i :class="contact.icon + ' contact-icon'"></i>
              <div>
                <p v-for="(line, i) in contact.lines" :key="i">{{ line }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="copyright">
          <p>
            Copyright © 2025 大白主动健康科技（南京）有限公司 版权所有 |
            <a href="./privacyAgreementNew" style="color: var(--secondary)"
              >隐私政策</a
            >
            | <a href="./privacyAgreement" style="color: var(--secondary)">用户协议</a>
          </p>
          <p style="margin-top: 10px">
            健康分析报告非医疗诊断结论，仅供参考。<a
              style="color: rgb(163, 271, 255)"
              href="https://beian.miit.gov.cn"
              >苏ICP备2023008256号</a
            >
            <!-- <a
              style="color: rgb(163, 271, 255)"
              href="https://beian.mps.gov.cn/#/query/webSearch"
              >苏ICP备2023008256号</a
            > -->
          </p>
        </div>
      </footer>

      <!-- 回到顶部按钮 -->
      <div
        class="back-to-top"
        :class="{ visible: showBackToTop }"
        @click="scrollToTop"
      >
        <i class="fas fa-arrow-up"></i>
      </div>
    </div>
  </body>
</template>

<script>
import { getDownloadLink } from "../../api/login";
export default {
  data() {
    return {
      isScrolled: false,
      mobileMenuOpen: false,
      showBackToTop: false,
      animated: false,
      activeSection: "home",
      androidDownloadLink: "",
      navLinks: [
        { id: "home", text: "首页" },
        { id: "features", text: "功能特点" },
        { id: "security", text: "隐私安全" },
        { id: "values", text: "核心价值" },
        { id: "download", text: "下载应用" },
      ],
      values: [
        {
          icon: "fas fa-user-shield",
          title: "隐私优先设计",
          description:
            "您的健康数据100%加密存储，采用军事级安全防护，未经您授权绝不共享任何数据",
        },
        {
          icon: "fas fa-brain",
          title: "AI健康分析",
          description:
            "基于百万健康数据训练的AI模型，提供精准的健康评估和个性化改善建议",
        },
        {
          icon: "fas fa-bell",
          title: "实时预警系统",
          description:
            "7×24小时监测异常健康指标，及时推送预警信息，守护您和家人的健康安全",
        },
      ],
      features: [
        {
          icon: "fas fa-heartbeat",
          title: "健康数据监测",
          subtitle: "连接各类智能设备，全面追踪您的健康指标",
          items: [
            "实时心率监测与分析",
            "血压趋势追踪与预警",
            "血氧饱和度监测",
            "睡眠质量深度分析",
            "ECG心电图记录",
          ],
        },
        {
          icon: "fas fa-chart-line",
          title: "智能健康报告",
          subtitle: "基于AI的健康评估与个性化建议",
          items: [
            "周/月健康趋势分析",
            "个性化健康改善方案",
            "运动与营养计划",
            "慢病风险评估",
            "家庭健康报告共享",
          ],
        },
        {
          icon: "fas fa-shield-alt",
          title: "安全与隐私",
          subtitle: "您的数据安全是我们的首要任务",
          items: [
            "端到端数据加密传输",
            "阿里云安全存储认证",
            "严格的数据访问控制",
            "GDPR合规数据处理",
            "透明隐私政策",
          ],
        },
      ],
      securityPoints: [
        {
          icon: "fas fa-lock",
          title: "三重加密保护",
          description: "数据传输、存储、访问全程加密，采用256位SSL加密技术",
        },
        {
          icon: "fas fa-cloud",
          title: "安全云存储",
          description: "阿里云KMS密钥管理 + 分布式存储隔离，确保数据安全",
        },
        {
          icon: "fas fa-user-cog",
          title: "严格访问控制",
          description: "RBAC角色分级访问 + 操作留痕审计，杜绝未授权访问",
        },
      ],
      currentSecurity: {
        icon: "fas fa-lock",
        title: "三重加密保护",
      },
      downloadButtons: [
        {
          icon: "fab fa-apple download-icon",
          subtitle: "下载",
          title: "ios版",
          url: "",
        },
        {
          icon: "fab fa-android download-icon",
          subtitle: "下载",
          title: "Android版",
          url: "android",
        },
        {
          icon: "fas fa-qrcode download-icon",
          subtitle: "扫描二维码",
          title: "直接下载",
          url: "",
        },
      ],
      socialLinks: [
        { icon: "fab fa-weixin", link: "#" },
        { icon: "fab fa-weibo", link: "#" },
        { icon: "fab fa-qq", link: "#" },
        { icon: "fab fa-github", link: "#" },
      ],
      services: [
        { name: "健康监测", link: "#" },
        { name: "数据分析", link: "#" },
        { name: "家庭健康", link: "#" },
        { name: "企业健康方案", link: "#" },
        { name: "API接入", link: "#" },
      ],
      aboutLinks: [
        { name: "公司介绍", link: "#" },
        { name: "团队故事", link: "#" },
        { name: "加入我们", link: "#" },
        { name: "媒体报道", link: "#" },
        { name: "合作伙伴", link: "#" },
      ],
      contacts: [
        {
          icon: "fas fa-envelope",
          lines: ["客服邮箱: zch888@139.com", "隐私团队: zch888@139.com"],
        },
        {
          icon: "fas fa-phone-alt",
          lines: ["客服热线: 15895887135", "工作日 9:00-17:30"],
        },
        {
          icon: "fas fa-map-marker-alt",
          lines: ["南京市鼓楼区汉中门大街301号", "外包服务大厦AB座12层1212室"],
        },
      ],
    };
  },
  mounted() {
    getDownloadLink().then((res) => {
      console.log("test getDownloadLink", res);
      this.androidDownloadLink = res.data.downloadUrl;
      console.log("test androidDownloadLink", this.androidDownloadLink);
    });

    window.addEventListener("scroll", this.handleScroll);
    this.handleScroll();

    // 设置动画触发
    setTimeout(() => {
      this.animated = true;
    }, 300);

    // 初始化图表
    this.$nextTick(() => {
      this.initCharts();
    });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  methods: {
    // onload: function () {
    //     getDownloadLink().then((res) => {
    //         console.log('test getDownloadLink', res)
    //     });
    // },
    openArchive() {
      const url =
        "https://health-planet.oss-cn-shanghai.aliyuncs.com/report/2025-07-08/7bc98c9cbac4ec4583c83ed4e3b6165c29cf.png";
      const typeDetails = url.substring(url.length - 3);
      if (typeDetails === "pdf" || typeDetails === "PDF") {
        window.open(url, "_blank");
      } else if (typeDetails === "png" || typeDetails === "jpg") {
        const newWindow = window.open("");
        newWindow.document.body.innerHTML = '<img src="' + url + '" alt="">';
      }
    },
    handleScroll() {
      // 检测滚动位置
      this.isScrolled = window.scrollY > 50;
      this.showBackToTop = window.scrollY > 500;

      // 更新活动导航项
      const sections = document.querySelectorAll("section");
      sections.forEach((section) => {
        const top = section.offsetTop - 100;
        const bottom = top + section.offsetHeight;
        if (window.scrollY >= top && window.scrollY < bottom) {
          this.activeSection = section.id;
        }
      });
    },
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      this.mobileMenuOpen = false;
    },
    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId);
      if (element) {
        window.scrollTo({
          top: element.offsetTop - 80,
          behavior: "smooth",
        });
      }
      this.mobileMenuOpen = false;
    },
    showFeatureInfo(feature) {
      alert(`您选择了: ${feature.title}\n\n${feature.description}`);
    },
    toDownload(btn) {
      if (btn.url === "android") {
        // alert(`您选择了: ${this.androidDownloadLink}\n\n${this.androidDownloadLink}`);
        // this.$router.push({
        //     path: btn.url,
        // })
        window.open(this.androidDownloadLink);
      } else {
        alert(`敬请期待！`);
      }
    },
    selectSecurityPoint(index) {
      this.currentSecurity = this.securityPoints[index];
    },
    initCharts() {
      // 心率图表
      const heartRateChart = this.echarts.init(
        document.getElementById("heartRateChart")
      );
      heartRateChart.setOption({
        tooltip: {
          trigger: "axis",
        },
        grid: {
          left: "3%",
          right: "3%",
          bottom: "3%",
          top: "10%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"],
          axisLine: {
            lineStyle: {
              color: "rgba(255,255,255,0.3)",
            },
          },
        },
        yAxis: {
          type: "value",
          min: 50,
          max: 120,
          axisLine: {
            lineStyle: {
              color: "rgba(255,255,255,0.3)",
            },
          },
          splitLine: {
            lineStyle: {
              color: "rgba(255,255,255,0.1)",
            },
          },
        },
        series: [
          {
            data: [72, 68, 75, 70, 80, 76, 78],
            type: "line",
            smooth: true,
            lineStyle: {
              width: 3,
              color: "#ff6b6b",
            },
            itemStyle: {
              color: "#ff6b6b",
            },
            areaStyle: {
              color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "rgba(255, 107, 107, 0.5)" },
                { offset: 1, color: "rgba(255, 107, 107, 0.1)" },
              ]),
            },
          },
        ],
      });

      // 睡眠图表
      const sleepChart = this.echarts.init(
        document.getElementById("sleepChart")
      );
      sleepChart.setOption({
        tooltip: {
          trigger: "axis",
        },
        grid: {
          left: "3%",
          right: "3%",
          bottom: "3%",
          top: "10%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: ["深睡", "浅睡", "REM", "清醒"],
          axisLine: {
            lineStyle: {
              color: "rgba(255,255,255,0.3)",
            },
          },
        },
        yAxis: {
          type: "value",
          max: 5,
          axisLine: {
            lineStyle: {
              color: "rgba(255,255,255,0.3)",
            },
          },
          splitLine: {
            lineStyle: {
              color: "rgba(255,255,255,0.1)",
            },
          },
        },
        series: [
          {
            data: [2.5, 3.5, 1.5, 0.5],
            type: "bar",
            barWidth: "40%",
            itemStyle: {
              color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#00b3b3" },
                { offset: 1, color: "#0066cc" },
              ]),
            },
          },
        ],
      });

      // 步数图表
      const stepsChart = this.echarts.init(
        document.getElementById("stepsChart")
      );
      stepsChart.setOption({
        tooltip: {
          trigger: "axis",
        },
        grid: {
          left: "3%",
          right: "3%",
          bottom: "3%",
          top: "10%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: [
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
            "11",
            "12",
            "13",
            "14",
          ],
          axisLine: {
            lineStyle: {
              color: "rgba(255,255,255,0.3)",
            },
          },
        },
        yAxis: {
          type: "value",
          min: 0,
          max: 15000,
          axisLine: {
            lineStyle: {
              color: "rgba(255,255,255,0.3)",
            },
          },
          splitLine: {
            lineStyle: {
              color: "rgba(255,255,255,0.1)",
            },
          },
        },
        series: [
          {
            data: [
              8520, 7350, 10120, 9840, 12500, 11700, 8450, 11230, 9860, 13400,
              12000, 8900, 11300, 12600,
            ],
            type: "line",
            smooth: true,
            lineStyle: {
              width: 3,
              color: "#00cc99",
            },
            itemStyle: {
              color: "#00cc99",
            },
            areaStyle: {
              color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "rgba(0, 204, 153, 0.5)" },
                { offset: 1, color: "rgba(0, 204, 153, 0.1)" },
              ]),
            },
          },
        ],
      });

      // 血压图表
      const bpChart = this.echarts.init(document.getElementById("bpChart"));
      bpChart.setOption({
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["收缩压", "舒张压"],
          textStyle: {
            color: "rgba(255,255,255,0.8)",
          },
        },
        grid: {
          left: "3%",
          right: "3%",
          bottom: "3%",
          top: "15%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"],
          axisLine: {
            lineStyle: {
              color: "rgba(255,255,255,0.3)",
            },
          },
        },
        yAxis: {
          type: "value",
          min: 50,
          max: 180,
          axisLine: {
            lineStyle: {
              color: "rgba(255,255,255,0.3)",
            },
          },
          splitLine: {
            lineStyle: {
              color: "rgba(255,255,255,0.1)",
            },
          },
        },
        series: [
          {
            name: "收缩压",
            data: [128, 135, 130, 122, 140, 132, 125],
            type: "line",
            smooth: true,
            lineStyle: {
              width: 3,
              color: "#ff6b6b",
            },
            itemStyle: {
              color: "#ff6b6b",
            },
          },
          {
            name: "舒张压",
            data: [82, 85, 80, 78, 90, 85, 80],
            type: "line",
            smooth: true,
            lineStyle: {
              width: 3,
              color: "#4dc0ff",
            },
            itemStyle: {
              color: "#4dc0ff",
            },
          },
        ],
      });

      // 存储图表实例
      this.charts = {
        heartRateChart,
        sleepChart,
        stepsChart,
        bpChart,
      };

      // 响应窗口大小变化
      window.addEventListener("resize", () => {
        heartRateChart.resize();
        sleepChart.resize();
        stepsChart.resize();
        bpChart.resize();
      });
    },
  },
};
</script>

<style>
/* 全局样式 */
:root {
  --primary: #0066cc;
  --secondary: #00b3b3;
  --accent: #ff6b6b;
  --light: #f0f8ff;
  --dark: #0a2a43;
  --success: #00cc99;
}
</style>

<style scoped>

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Segoe UI", "PingFang SC", "Microsoft YaHei", sans-serif;
}

body {
  background: linear-gradient(135deg, #0a2a43 0%, #1a3a5a 100%);
  color: #fff;
  line-height: 1.6;
  overflow-x: hidden;
  position: relative;
}

body::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(
      circle at 10% 20%,
      rgba(0, 150, 255, 0.1) 0%,
      transparent 20%
    ),
    radial-gradient(
      circle at 90% 80%,
      rgba(0, 255, 200, 0.1) 0%,
      transparent 20%
    ),
    radial-gradient(
      circle at 30% 60%,
      rgba(0, 200, 255, 0.1) 0%,
      transparent 25%
    );
  pointer-events: none;
  z-index: -1;
}

/* #app {
  max-width: 1400px;
  margin: 0 auto;
  overflow: hidden;
  height: max-content;
} */

.home-page-container {
  max-width: 1400px;
  margin: 0 auto;
  overflow: hidden;
  height: max-content;
}

/* 导航栏样式 */
header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  background: rgba(10, 40, 70, 0.95);
  backdrop-filter: blur(10px);
  padding: 15px 0;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
  border-bottom: 1px solid rgba(0, 150, 255, 0.3);
  transition: all 0.3s ease;
}

.scrolled {
  padding: 10px 0;
  background: rgba(10, 30, 60, 0.98);
}

.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.logo {
  display: flex;
  align-items: center;
  gap: 15px;
  cursor: pointer;
}

.logo-icon {
  font-size: 2rem;
  color: var(--success);
  transition: transform 0.3s ease;
}

.logo:hover .logo-icon {
  transform: scale(1.1);
}

.logo-text {
  font-size: 1.8rem;
  font-weight: 700;
  background: linear-gradient(to right, var(--primary), var(--secondary));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.nav-links {
  display: flex;
  gap: 30px;
}

.nav-links a {
  color: #e6f7ff;
  text-decoration: none;
  font-weight: 500;
  position: relative;
  padding: 5px 0;
  transition: all 0.3s ease;
}

.nav-links a:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background: var(--secondary);
  transition: width 0.3s ease;
}

.nav-links a:hover:after,
.nav-links a.active:after {
  width: 100%;
}

.nav-links a.active {
  color: #4dc0ff;
}

.mobile-menu-btn {
  display: none;
  background: none;
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
}

.cta-button {
  background: linear-gradient(120deg, var(--primary), var(--secondary));
  color: white;
  padding: 12px 30px;
  border-radius: 30px;
  text-decoration: none;
  font-weight: 600;
  box-shadow: 0 5px 15px rgba(0, 102, 204, 0.4);
  transition: all 0.3s ease;
  border: none;
  cursor: pointer;
}

.cta-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(0, 102, 204, 0.6);
}

/* 主视觉区域 */
.hero {
  padding: 180px 0 100px;
  text-align: center;
  position: relative;
  overflow: hidden;
  max-width: 1200px;
  margin: 0 auto;
}

.hero::before {
  content: "";
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(
      circle,
      rgba(0, 150, 255, 0.1) 0%,
      transparent 70%
    ),
    radial-gradient(
      circle at top right,
      rgba(0, 255, 200, 0.1) 0%,
      transparent 70%
    );
  z-index: -1;
  animation: rotate 30s linear infinite;
}

.hero-content {
  max-width: 800px;
  margin: 0 auto;
  position: relative;
  z-index: 2;
}

.hero h1 {
  font-size: 3.5rem;
  font-weight: 800;
  margin-bottom: 20px;
  line-height: 1.2;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.hero-gradient {
  background: linear-gradient(to right, var(--primary), var(--secondary));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.hero p {
  font-size: 1.4rem;
  max-width: 700px;
  margin: 0 auto 40px;
  opacity: 0.9;
  text-shadow: 0 1px 5px rgba(0, 0, 0, 0.2);
}

.hero-image {
  max-width: 900px;
  margin: 50px auto 0;
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(0, 150, 255, 0.3);
  background: linear-gradient(120deg, #0a2a43, #1a3a5a);
  height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 2rem;
  flex-direction: column;
  position: relative;
  overflow: hidden;
}

.hero-image::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url("https://images.unsplash.com/photo-1532938911079-1b06ac7ceec7?ixlib=rb-1.2.1&auto=format&fit=crop&w=1920&q=80")
    center/cover no-repeat;
  opacity: 0.4;
}

.dashboard-preview {
  width: 90%;
  height: 85%;
  background: rgba(10, 30, 50, 0.8);
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: 20px;
  gap: 20px;
}

.dashboard-chart {
  background: rgba(15, 40, 70, 0.7);
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}

.chart-title {
  font-size: 1rem;
  margin-bottom: 10px;
  color: #4dc0ff;
  text-align: center;
}

.chart-container {
  width: 100%;
  height: 150px;
}

.heart-icon {
  font-size: 5rem;
  margin-bottom: 20px;
  animation: heartbeat 1.5s infinite;
  position: relative;
  z-index: 2;
  text-shadow: 0 0 20px rgba(255, 0, 0, 0.5);
}

/* 核心价值部分 */
.values {
  padding: 100px 20px;
  background: rgba(15, 50, 90, 0.7);
  position: relative;
  overflow: hidden;
}

.values::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(
      circle at 20% 30%,
      rgba(0, 200, 255, 0.1) 0%,
      transparent 40%
    ),
    radial-gradient(
      circle at 80% 70%,
      rgba(0, 255, 200, 0.1) 0%,
      transparent 40%
    );
  z-index: -1;
}

.section-title {
  text-align: center;
  margin-bottom: 70px;
  max-width: 1200px;
  margin: 0 auto 70px;
  padding: 0 20px;
}

.section-title h2 {
  font-size: 2.5rem;
  margin-bottom: 20px;
  color: #4dc0ff;
  position: relative;
  display: inline-block;
}

.section-title h2::after {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 4px;
  background: var(--secondary);
  border-radius: 2px;
}

.section-title p {
  max-width: 700px;
  margin: 0 auto;
  font-size: 1.2rem;
  opacity: 0.8;
}

.value-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.value-card {
  background: rgba(20, 60, 100, 0.6);
  border-radius: 15px;
  padding: 40px 30px;
  text-align: center;
  transition: all 0.4s ease;
  border: 1px solid rgba(0, 150, 255, 0.3);
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.value-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(0, 102, 204, 0.1), transparent);
  z-index: 1;
}

.value-card:hover {
  transform: translateY(-10px);
  background: rgba(0, 102, 204, 0.3);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.3);
}

.value-icon {
  width: 80px;
  height: 80px;
  background: rgba(0, 102, 204, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 25px;
  font-size: 2rem;
  color: var(--secondary);
  transition: all 0.3s ease;
  position: relative;
  z-index: 2;
}

.value-card:hover .value-icon {
  transform: scale(1.1);
  background: rgba(0, 102, 204, 0.4);
}

.value-card h3 {
  font-size: 1.6rem;
  margin-bottom: 20px;
  color: #a3d9ff;
  position: relative;
  z-index: 2;
}

.value-card p {
  position: relative;
  z-index: 2;
}

/* 产品功能部分 */
.features {
  padding: 100px 20px;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
}

.features::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(
      circle at 90% 10%,
      rgba(0, 200, 255, 0.1) 0%,
      transparent 40%
    ),
    radial-gradient(
      circle at 10% 90%,
      rgba(0, 255, 200, 0.1) 0%,
      transparent 40%
    );
  z-index: -1;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 40px;
}

.feature-card {
  background: rgba(15, 50, 90, 0.8);
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(0, 150, 255, 0.3);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.feature-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(0, 102, 204, 0.1), transparent);
  z-index: 1;
}

.feature-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.3);
}

.feature-image {
  height: 200px;
  background: linear-gradient(120deg, var(--primary), var(--secondary));
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 4rem;
  color: white;
  position: relative;
  overflow: hidden;
}

.feature-image::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url("https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-1.2.1&auto=format&fit=crop&w=2070&q=80")
      center/cover no-repeat,
    linear-gradient(120deg, rgba(0, 102, 204, 0.7), rgba(0, 179, 179, 0.7));
  /* linear-gradient(120deg, rgb(255,255,255), rgb(255,255,255)); */
  opacity: 0.7;
  mix-blend-mode: multiply;
}

.feature-image i {
  position: relative;
  z-index: 2;
  text-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
}

.feature-card:nth-child(2) .feature-image::before {
  background: url("https://images.unsplash.com/photo-1586769852836-bc069f19e1b6?ixlib=rb-1.2.1&auto=format&fit=crop&w=2070&q=80")
      center/cover no-repeat,
    linear-gradient(120deg, rgba(0, 102, 204, 0.7), rgba(0, 179, 179, 0.7));
}

.feature-card:nth-child(3) .feature-image::before {
  background: url("https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-1.2.1&auto=format&fit=crop&w=2070&q=80")
      center/cover no-repeat,
    linear-gradient(120deg, rgba(0, 102, 204, 0.7), rgba(0, 179, 179, 0.7));
}

.feature-content {
  padding: 30px;
  position: relative;
  z-index: 2;
}

.feature-card h3 {
  font-size: 1.5rem;
  margin-bottom: 15px;
  color: #4dc0ff;
}

.feature-list {
  list-style: none;
  margin-top: 20px;
}

.feature-list li {
  padding: 10px 0;
  padding-left: 30px;
  position: relative;
  transition: all 0.3s ease;
}

.feature-list li:hover {
  color: var(--secondary);
  transform: translateX(5px);
}

.feature-list li:before {
  content: "\f00c";
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  position: absolute;
  left: 0;
  color: var(--success);
}

/* 安全隐私部分 */
.security {
  padding: 100px 20px;
  background: rgba(15, 50, 90, 0.7);
  position: relative;
  overflow: hidden;
}

.security::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(
      circle at 30% 20%,
      rgba(0, 150, 255, 0.1) 0%,
      transparent 40%
    ),
    radial-gradient(
      circle at 70% 80%,
      rgba(0, 255, 200, 0.1) 0%,
      transparent 40%
    );
  z-index: -1;
}

.security-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 50px;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
}

.security-text h2 {
  font-size: 2.5rem;
  margin-bottom: 30px;
  color: #4dc0ff;
  position: relative;
  display: inline-block;
}

.security-text h2::after {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 0;
  width: 80px;
  height: 4px;
  background: var(--secondary);
  border-radius: 2px;
}

.security-points {
  margin-top: 30px;
}

.security-point {
  display: flex;
  gap: 20px;
  margin-bottom: 30px;
  transition: all 0.3s ease;
  cursor: pointer;
  padding: 10px;
  border-radius: 8px;
  background: rgba(20, 60, 100, 0.4);
}

.security-point:hover {
  background: rgba(0, 102, 204, 0.2);
}

.security-icon {
  width: 60px;
  height: 60px;
  background: rgba(0, 102, 204, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  color: var(--secondary);
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.security-point:hover .security-icon {
  transform: rotate(15deg);
  background: rgba(0, 102, 204, 0.4);
}

.security-image {
  border-radius: 15px;
  height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 4rem;
  color: white;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.3);
  padding: 20px;
  text-align: center;
  position: relative;
  overflow: hidden;
  background:
            /* linear-gradient(120deg, rgba(0, 102, 204, 0.7), rgba(0, 179, 179, 0.7)), */ url("https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-1.2.1&auto=format&fit=crop&w=2070&q=80")
    center/cover no-repeat;
}

.security-image i {
  position: relative;
  z-index: 2;
  text-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
}

.security-image p {
  margin-top: 20px;
  font-size: 1.2rem;
  position: relative;
  z-index: 2;
}

/* 下载区域 */
.download {
  padding: 100px 20px;
  text-align: center;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
}

.download::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(
      circle at 80% 20%,
      rgba(0, 150, 255, 0.1) 0%,
      transparent 40%
    ),
    radial-gradient(
      circle at 20% 80%,
      rgba(0, 255, 200, 0.1) 0%,
      transparent 40%
    );
  z-index: -1;
}

.download-content {
  max-width: 700px;
  margin: 0 auto;
}

.download h2 {
  font-size: 2.5rem;
  margin-bottom: 20px;
  position: relative;
  display: inline-block;
}

.download h2::after {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 4px;
  background: var(--secondary);
  border-radius: 2px;
}

.download p {
  font-size: 1.2rem;
  max-width: 600px;
  margin: 0 auto 30px;
}

.download-buttons {
  display: flex;
  justify-content: center;
  gap: 30px;
  margin-top: 40px;
  flex-wrap: wrap;
}

.download-btn {
  background: rgba(20, 60, 100, 0.6);
  border-radius: 15px;
  padding: 20px 40px;
  display: flex;
  align-items: center;
  gap: 15px;
  text-decoration: none;
  color: white;
  font-weight: 600;
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 150, 255, 0.3);
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.download-btn::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  transition: 0.5s;
}

/* .download-btn:hover::before {
        left: 100%;
    }

    .download-btn:hover {
        background: rgba(0, 102, 204, 0.3);
        transform: translateY(-5px);
    } */

.download-icon {
  font-size: 2rem;
}

/* 页脚 */
footer {
  background: linear-gradient(120deg, #003366, #001a33);
  padding: 70px 20px 30px;
  position: relative;
}

footer::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(
      circle at 20% 30%,
      rgba(0, 150, 255, 0.1) 0%,
      transparent 30%
    ),
    radial-gradient(
      circle at 80% 70%,
      rgba(0, 255, 200, 0.1) 0%,
      transparent 30%
    );
  z-index: 1;
}

.footer-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 40px;
  margin-bottom: 50px;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 2;
}

.footer-col h3 {
  font-size: 1.4rem;
  margin-bottom: 25px;
  color: #4dc0ff;
  position: relative;
  padding-bottom: 10px;
}

.footer-col h3:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 50px;
  height: 2px;
  background: var(--secondary);
}

.footer-links {
  list-style: none;
}

.footer-links li {
  margin-bottom: 15px;
}

.footer-links a {
  color: #a3d9ff;
  text-decoration: none;
  transition: all 0.3s ease;
  display: inline-block;
}

.footer-links a:hover {
  color: var(--secondary);
  transform: translateX(5px);
}

.contact-item {
  display: flex;
  gap: 15px;
  margin-bottom: 20px;
  align-items: flex-start;
}

.contact-icon {
  color: var(--secondary);
  font-size: 1.2rem;
  margin-top: 5px;
}

.copyright {
  text-align: center;
  padding-top: 30px;
  border-top: 1px solid rgba(0, 150, 255, 0.2);
  color: #a3d9ff;
  font-size: 0.9rem;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 2;
}

/* 响应式设计 */
@media (max-width: 992px) {
  .hero h1 {
    font-size: 2.8rem;
  }

  .security-content {
    grid-template-columns: 1fr;
  }

  .security-image {
    height: 300px;
    margin-top: 30px;
  }
}

@media (max-width: 768px) {
  .nav-links {
    display: none;
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background: rgba(10, 30, 60, 0.98);
    flex-direction: column;
    padding: 20px;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
  }

  .nav-links.active {
    display: flex;
  }

  .mobile-menu-btn {
    display: block;
  }

  .hero {
    padding: 150px 0 70px;
  }

  .hero h1 {
    font-size: 2.2rem;
  }

  .hero p {
    font-size: 1.1rem;
  }

  .section-title h2 {
    font-size: 2rem;
  }

  .download-btn {
    width: 100%;
  }

  .dashboard-preview {
    grid-template-columns: 1fr;
  }
}

/* 动画效果 */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes heartbeat {
  0% {
    transform: scale(1);
  }

  14% {
    transform: scale(1.15);
  }

  28% {
    transform: scale(1);
  }

  42% {
    transform: scale(1.15);
  }

  70% {
    transform: scale(1);
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.animate {
  animation: fadeInUp 0.8s ease-out forwards;
  opacity: 0;
}

.show {
  opacity: 1;
}

.back-to-top {
  position: fixed;
  bottom: 40px;
  right: 40px;
  width: 60px;
  height: 60px;
  background: var(--primary);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  z-index: 100;
  font-size: 1.5rem;
  opacity: 0;
  transform: translateY(20px);
}

.back-to-top.visible {
  opacity: 1;
  transform: translateY(0);
}

.back-to-top:hover {
  background: var(--secondary);
  transform: translateY(-5px) scale(1.1);
}
</style>
